import SpPreview from "~/components/Articles/SpPreview";
import PreviewHeaderScrollNavi from "~/components/Articles/PreviewHeaderScrollNavi";
import ContentsRightAttachmentDownloadButton from "~/components/Articles/ContentsRightAttachmentDownloadButton";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import { createApp } from "vue";

document.addEventListener("DOMContentLoaded", () => {
  const app = createApp({
    components: {
      SpPreview,
      PreviewHeaderScrollNavi,
    },    
    data() {
      return {
        showHeaderScrollNavi: true,
        isPcPreview: false,
      };
    },
    mounted() {
      window.addEventListener("scroll", this.handleScroll);
      $("#pressrelease_detail_contents").hide();
      $("#scrollMenu").hide();
      $("#footer").hide();
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
      handleScroll() {
        const header = document.querySelector("#pressrelease_detail_contents");
        var rect = header.getBoundingClientRect().top;
        if (rect <= 20) {
          this.showHeaderScrollNavi = true;
        } else {
          this.showHeaderScrollNavi = false;
        }
      },
      showPcPreview() {
        this.isPcPreview = true;
        $("#scrollMenu").show();
        $("#footer").show();
        $("#pressrelease_detail_contents").show();
        this.handleScroll();
      },
      showSpPreview() {
        this.isPcPreview = false;
        $("#scrollMenu").hide();
        $("#footer").hide();
        $("#pressrelease_detail_contents").hide();
        this.handleScroll();
      }
    }
  });
  app.use(FloatingVue);
  app.mount("#articles_new");
  const contentsRightAttachmentDownloadButton = createApp({
    components: {
      ContentsRightAttachmentDownloadButton,
    }
  });
  contentsRightAttachmentDownloadButton.use(FloatingVue);
  contentsRightAttachmentDownloadButton.mount("#contents-right-attachment-download-button");
});
